import {useEffect, useState} from "react";
import {searchApi} from "../api/searchApi";
import {useDebounceFn} from "@/shared/lib/hooks/useDebounceFn";

type Params = {
    query: string;
    enabled?: boolean;
    searchType: string;
    page: number;
    perPage: number;
    filterParams: Record<string, unknown>;
    staticFilterParams: Record<string, unknown>;
    sort: string;
};

export const useSearchSuggestions = (
    {
        query,
        enabled = true,
        searchType,
        page,
        perPage,
        filterParams,
        staticFilterParams,
        sort,
    }: Params
) => {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSuggestions = useDebounceFn(
        async (searchQuery: string) => {
            if (!searchQuery.trim()) {
                setSuggestions([]);
                return;
            }

            try {
                setLoading(true);

                const data = await searchApi.getSuggestions({
                    query: searchQuery,
                    searchType,
                    page,
                    perPage,
                    filterParams,
                    staticFilterParams,
                    sort,
                });

                setSuggestions(data);
            } finally {
                setLoading(false);
            }
        },
        500
    );

    useEffect(() => {
        if (!enabled) {
            return;
        }

        fetchSuggestions(query);
    }, [query]);

    return {
        suggestions,
        loading,
    };
};
